import styled from "styled-components";

export default function OrderDetailTop({ children }) {
  return <Block>{children}</Block>;
}

const Block = styled.div`
  background-color: #ffffff;
  padding-top: calc(100vw * (23 / 375));
  padding-left: calc(100vw * (17 / 375));
  padding-right: calc(100vw * (17 / 375));
  padding-bottom: calc(100vw * (37 / 375));
  border-bottom: calc(100vw * (12 / 375)) solid #f7f7f7;

  /* margin-bottom: calc(100vw * (12 / 375)); */
`;
